import Vue from 'vue';

import MaCode from '../components/ma-code.vue';
import Slick from 'vue-slick';

new Vue({
    el: '#styleguide',

    delimiters: ['${', '}'],

    components: {
        MaCode,
        Slick
    },

    data: {
        quantity: 1
    },

    methods: {
        updateQuantity(quantity) {
            if (!isNaN(quantity) && quantity >= 1) {
                this.quantity = quantity;
            } else {
                this.quantity = 1;
            }
        },
    }
});